import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {RestApiService} from '../../../../core/services/http/rest-api.service';
import {Observable} from 'rxjs';
import {ApiRoutesEnum} from '../../../../core/services/http/api-routes.enum';
import {ApiSensorsListPaginatedQueryParams} from './api-sensors-list-paginated-query-params';
import {ApiSensorsListResponse} from './api-sensors-list-response';
import {ApiSensorResponse} from './api-sensor-response';
import {ApiBatchCreateSensorRequest} from './api-batch-create-sensor-request';
import {ApiSendBundleRequest} from './api-send-bundle-request';
import {ApiCreateOrderRequest} from './api-create-order-request';
import {ApiIndicateSterilizedRequest} from './api-indicate-sterilized-request';

@Injectable()
export class SensorRestApiService {

  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _restApiService: RestApiService,
  ) {
  }

  public requestSensor(sensorId: string): Observable<ApiSensorResponse> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.SENSORS,
      sensorId,
    ].join('/');
    return this._httpClient.get<ApiSensorResponse>(url);
  }

  public requestSensorsListPaginated(
    queryParams: ApiSensorsListPaginatedQueryParams,
  ): Observable<ApiSensorsListResponse> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.SENSORS,
    ].join('/');
    const params: HttpParams = this._restApiService.createHttpParams(queryParams);
    return this._httpClient.get<ApiSensorsListResponse>(url, {params: params});
  }

  public requestBatchCreate(data: ApiBatchCreateSensorRequest): Observable<Array<ApiSensorResponse>> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.SENSORS_BATCH_CREATE,
    ].join('/');
    return this._httpClient.post<Array<ApiSensorResponse>>(url, data);
  }

  public requestSendBundle(data: ApiSendBundleRequest): Observable<void> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.SENSORS_SEND_TO_SUBCONTRACTOR,
    ].join('/');
    return this._httpClient.post<void>(url, data);
  }

  public requestIndicateSterilized(data: ApiIndicateSterilizedRequest): Observable<void> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.SENSORS_INDICATE_STERILIZED,
    ].join('/');
    return this._httpClient.put<void>(url, data);
  }

  public requestCreateOrder(data: ApiCreateOrderRequest): Observable<void> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.SENSORS_ORDERS,
    ].join('/');
    return this._httpClient.post<void>(url, data);
  }
}
